import { KeyMetric } from '@/components/KeyMetric';
import { toTruncated } from '@/utilities/formatting';
import { Grid, Text } from '@simplywallst/ui-core';

type Props = {
  type: 'revenueGrowth' | 'analystCount';
  revenuePercentageChange: number | null;
  priceTargetAnalystCount: number | null | undefined;
};

export const SecondaryKeyMetric = ({
  type,
  revenuePercentageChange,
  priceTargetAnalystCount,
}: Props) => {
  if (type === 'revenueGrowth' && typeof revenuePercentageChange === 'number')
    return (
      <KeyMetric color="brand01">
        <Grid templateRows="max-content max-content">
          <Text typography="largeStrong" color="textSolid">
            {toTruncated(revenuePercentageChange, 2)}%
          </Text>
          <Text typography="xSmall" color="textSoft">
            Revenue growth p.a.
          </Text>
        </Grid>
      </KeyMetric>
    );

  if (type === 'analystCount' && typeof priceTargetAnalystCount === 'number')
    return (
      <KeyMetric color="brand01">
        <Grid templateRows="max-content max-content">
          <Text typography="largeStrong" color="textSolid">
            {toTruncated(priceTargetAnalystCount, 0)}
          </Text>
          <Text typography="xSmall" color="textSoft">
            Number of Analysts
          </Text>
        </Grid>
      </KeyMetric>
    );

  return null;
};
